import React from "react";
import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label }) => {
    return (
        <Link
            to='#'
            onClick={(e) => {
                window.location = mailto;
                e.preventDefault();
            }}
            style={{ color: "#979797" }}
        >
            {label}
        </Link>
    );
};

export default ButtonMailto;